import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import './Footer.css';

const Footer = ({ settings, services }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <img
                src={settings.logo_footer || ''}
                alt="Centro Terapéutico Crecer Juntos"
                className="footer-logo-image"
              />
            </div>
            <p className="footer-description">
              Acompañamos el desarrollo integral de tu hijo con terapias especializadas en un ambiente cálido y profesional.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Navegación</h4>
            <ul className="footer-links">
              <li>
                <button onClick={() => scrollToSection('inicio')} className="footer-link">
                  Inicio
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('servicios')} className="footer-link">
                  Nuestros Servicios
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('equipo')} className="footer-link">
                  Nuestro Equipo
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('salas')} className="footer-link">
                  Nuestras Salas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contacto')} className="footer-link">
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Nuestros Servicios</h4>
            <ul className="footer-links">
              {services.map((s) => (
                <li key={s.id} className="footer-link">{s.title}</li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Contacto</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>{settings.address || ''}</span>
              </li>
              <li>
                <Phone size={18} />
                <span>{settings.phone || ''}</span>
              </li>
              <li>
                <Mail size={18} />
                <span>{settings.email || ''}</span>
              </li>
              <li>
                <Clock size={18} />
                <span>{settings.hours || ''}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-divider"></div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© {new Date().getFullYear()} Centro Terapéutico Crecer Juntos. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
